module.exports = require("cytoscape-popper");